import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Tabs, Tab } from '@mui/material';
import { fetchDashboardData } from '../../../services/api';

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchDashboardData();
        setData(response.data);
      } catch (error) {
        console.error('Error loading dashboard data:', error);
      }
    };

    loadData();
  }, []);

  return (
    <Container>
      <Typography variant="h4" sx={{ my: 4 }}>
        Admin Dashboard
      </Typography>
      <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
        <Tab label="Announcements" />
        <Tab label="Board Members" />
        <Tab label="Gallery" />
        <Tab label="Tribute" />
      </Tabs>
      <Box sx={{ mt: 4 }}>
        {/* Add content for each tab */}
      </Box>
    </Container>
  );
};

export default Dashboard; 